<template>
  <Screen>
    <AppBar
      title="Manage E-books"
      :description="`Add or update E-books`"
      :showBackButton="false"
    >
      <inertia-link
        :href="$route('admin.ebooks.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="E-books" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <div class="table-responsive" v-if="data.data.length > 0">
          <table class="table mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Status</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.data" :key="item.id">
                <td>
                  {{
                    i + 1 + (data.meta.current_page - 1) * data.meta.per_page
                  }}
                </td>
                <td>
                  <img
                    v-lazy="item.thumbnail"
                    :alt="item.title"
                    class="thumbnail"
                    width="60"
                    height="100"
                    style="background-color: #f1f1f1"
                  />
                </td>
                <th>
                  {{ item.title }}
                  <div class="sub-title mb-1" v-text="item.author"></div>
                  <a
                    :href="item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="sub-title"
                    >{{ item.link }}</a
                  >
                </th>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.isactive"
                    action="ebookStatus"
                  />
                </th>
                <td>{{ item.created_at_human || "-" }}</td>
                <td>{{ item.updated_at_human || "-" }}</td>
                <td>
                  <inertia-link
                    class="btn btn-sm btn-light"
                    :href="
                      $route('admin.ebooks.edit', {
                        id: item.id,
                      })
                    "
                  >
                    Update
                  </inertia-link>
                  <button
                    @click.prevent="deleteThis(item.id)"
                    class="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <NoData title="No ebooks added yet" v-else>
          <inertia-link
            :href="$route('admin.ebooks.create')"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Add new
          </inertia-link>
        </NoData>
        <Pagination :rawData="data.meta" :onClick="pageChange" />
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    async deleteThis(id) {
      this.$root.$emit("confirmModal", {
        title: "Do you want to delete this E-book?",
        message: "You won't be able to revert this!",
        confirmText: "Yes, delete it!",
        onConfirm: () => {
          this.$root.$emit("hold-transition", null);
          this.$inertia.delete(
            this.$route("admin.ebooks.delete", {
              id: id,
            })
          );
        },
      });
    },
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.thumbnail {
  object-fit: cover;
  border-radius: 5px;
  height: 100px;
  width: auto;
  max-width: 200px;
  background-color: #fff;
}
</style>
